declare const THREE: any;

const getMouse = (): any => {
  return new THREE.Vector2();
};

export default getMouse;
